module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAASZJREFUSEvNli1LREEUhp8H/AFGozajYDEoKBaDYDLY3CBWm1WjIJgFgyaN2gyCBn/ARsOCBoM/wGAQjsyyK8t69+PO3QtOnXPeZ94zw8tIzcua9fkFRMQ6cAHMTgD6DDTUVi/gdULi3fPdqDu9gOjsrADvFVwsAdfAk7pWBJhT33IBEbEKPP4PQEScAQtjuLlXT1JdKQcRkawmy6PWpdrIAaTTT49SBz7Ul9KAMYT/lJQd0SEwPwB0q97175UFDLuDI/W4KmADmBngoKk2KwFqv4NaARGxCGxmQFIa7w6NCmALOAWmMgDdlvYjKAq7lOXLnaqHzGRNGlfqdxEgaX8BB+p5BQft1iJAC9gueoI5sH7ADbCnfuaIFfX0AvYnMZJ+SO2/ih+W/s0ZYXi/BgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bookIcons/commit2.png
// module id = Sf3I
// module chunks = 1